//查看供应商
<template>
  <div v-loading="!show"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading">
    <el-card shadow="hover">
      <div class="head-tit">账单详情</div>
    </el-card>
    <div class="supplier-info">
      <div class="supplierName">
        <img src="../../assets/images/billLogo.png">
        <h3>供应商:{{billList.ybSupplierCode}}</h3>
        <div class="pay-style">
          <p class="pay-status">
            <span style="color: #888">状态</span>
            <span v-if="billList.ybStatus === 3"
                  style="display:block;font-size:28px;height:50px;line-height:50px">未支付</span>
            <span v-else-if="billList.ybStatus === 1"
                  style="display:block;font-size:28px;height:50px;line-height:50px">已支付</span>
            <span v-else-if="billList.ybStatus === 2"
                  style="display:block;font-size:28px;height:50px;line-height:50px">已取消</span>
            <span v-else-if="billList.ybStatus === 0"
                  style="display:block;font-size:28px;height:50px;line-height:50px">未核对</span>
          </p>
          <p class="pay-money">
            <span style="color: #888">账单总金额</span>
            <span style="display:block;font-size:28px;height:50px;line-height:50px">¥{{billList.ybTotalMoney|toFixed}}</span>
          </p>
        </div>
      </div>

      <div class="bill-desc">
        <div class="pay-type">
          <span>账单编号：</span><span class="bill-text">{{billList.ybCode}}</span>
          <span>支付方式：</span>
          <span class="bill-text"
                v-if="billList.ybPayType === 0">在线支付</span>
          <span class="bill-text"
                v-else-if="billList.ybPayType === 1">线下支付</span>
          <span class="bill-text"
                v-else></span>
        </div>

        <div class="pay-down-style">
          <div class="pay-time">
            <span>生成时间：</span><span class="bill-text">{{billList.ybGenTime}}</span>
            <span>支付时间：</span><span class="bill-text">{{billList.ybPaySucTime}}</span>
          </div>
          <div>
            <span>取消时间：</span><span class="bill-text">{{billList.ybCancelTime}}</span>
          </div>
          <div style="width:1200px">
            <span>支付凭证：</span>
            <span class="bill-text defSpan"
                  v-if="billList.ybStatus !== 1">
              这是一条支付凭证的留言信息，可能是支付流水号之类的……</span>
            <span v-else
                  class="bill-text defSpan">{{billList.ybVoucher}}</span>
          </div>

          <div v-if="show">
            <upload-pic ref="upload"
                        :pictureList="urlPicArr"
                        :isDisabled="true"
                        :limit="3"></upload-pic>
          </div>
        </div>

      </div>
    </div>
    <div class="billInfo"
         v-if="show">
      <el-menu default-active="-1"
               mode="horizontal"
               @select="handleStatusSelect">
        <el-menu-item index="-1">费用明细</el-menu-item>
        <el-menu-item index="0">账单统计</el-menu-item>
      </el-menu>
      <!-- 列表1 S -->
      <div :class="costClass">
        <page-table ref="pageTable1"
                    :list="costListPage"
                    :fieldList="fieldList">
          <template v-slot:col-ycCode="scope">
            <span v-if="scope.row.moneyType === '仓储费'"
                  style="width:100%;color:#409Eff;cursor:pointer;"
                  @click="detailYcCode(scope.row)">{{scope.row.ycCode}}</span>
            <span v-else-if="
                  scope.row.moneyType==='退货费'"
                  style="
                  width:100%;color:#409Eff;cursor: pointer;"
                  @click="detailYcCode(scope.row)">{{scope.row.ycCode}}</span>
            <span v-else-if="
                  scope.row.moneyType==='配送费'"
                  style="
                  width:100%;color:#409Eff;cursor: pointer;"
                  @click="detailYcCode(scope.row)">{{scope.row.ycCode}}</span>
            <span v-else-if="scope.row.moneyType === '装卸费'"
                  style="width:100%;color:#409Eff;cursor: pointer;"
                  @click="detailYcCode(scope.row)">{{scope.row.ycCode}}</span>
            <span v-else-if="scope.row.moneyType === '其他费用'"
                  style="width:100%;color:#409Eff;cursor: pointer;"
                  @click="detailYcCode(scope.row)">{{scope.row.ycCode}}</span>
            <span v-else
                  style="
                  width:100%;">{{scope.row.ycCode}}</span>
          </template>
          <template v-slot:col-taskCode="scope">
            <span v-if="scope.row.moneyType === '仓储费'">-</span>
            <span v-else-if="scope.row.moneyType === '贴标费'"
                  style="width:100%;">{{scope.row.taskCode}}</span>
            <span v-else-if="scope.row.moneyType === '包膜费'"
                  style="width:100%;">{{scope.row.taskCode}}</span>
            <span @click="detail(scope.row)"
                  v-else
                  style="width:100%;color:#409Eff;cursor: pointer;">{{scope.row.taskCode}}</span>
          </template>
        </page-table>
        <div class="button-list">
          <el-button @click="comeBack"
                     v-if="buttonHide(billList,0)">返回</el-button>
          <el-button @click="handleCancelBill"
                     v-if="buttonHide(billList,1) && !isAdmin"
                     :disabled="$has('billCancel')">取消账单</el-button>
          <el-button @click="payOffline"
                     v-if="buttonHide(billList,1) && !isAdmin"
                     :disabled="$has('billManagesEdit')">线下支付</el-button>
        </div>
      </div>
      <!-- 列表1 E -->

      <!-- 列表2 S -->
      <page-table ref="pageTable2"
                  :list="costGrouplist"
                  :fieldList="costFieldList"
                  :class="countClass">
      </page-table>
      <!-- 列表2 E -->
    </div>
    <!-- 线下支付 S -->
    <dialog-form width="50%"
                 append-to-body
                 :dialogTitle="dialogData.title"
                 :dialogVisible="dialogData.visible"
                 :handleClose="handleFormClose"
                 :fileList="formFieldList"
                 :data="formInfo.data"
                 permission="billManages"
                 :isMoreUpload="true"
                 :submit="handleSubmit">
      <template v-slot:form-url>
        <upload-pic ref="upload"
                    :fileIds="formInfo.data.url"
                    :pictureList="formInfo.data.pic"
                    :limit="3"
                    :isDisabled="false"
                    :delet="true"></upload-pic>
        <label class="upload-text">建议＜3M，最多3张</label>
      </template>
    </dialog-form>
    <!-- 线下支付 E -->
  </div>
</template>
<script>
import { GETBILLDETAIL, GETGROUPCOST, OFFLINEPAY, CANCELBILL } from '../../store/billManage/types.js'
import billManage from '@/store/billManage/index'
import pageTable from '@/components/Table/Index'
import dialogForm from '@/components/Form/DialogForm'
import uploadPic from '@/page/assignmentManage/components/uploadImage.vue'
import {toWarehouse} from '@/utils/toWarehouse'

export default {
  name: 'billcheck',
  components: {
    pageTable, dialogForm, uploadPic
  },
  data () {
    return {
      costClass: 'costInfo',
      countClass: 'billStat div-hide',
      page: 1,
      size: 10,
      hi_lite: 'hi_lite',
      down_lite: 'down_lite',
      dialogData: {
        title: '线下支付凭证编辑',
        visible: false
      },
      formInfo: {
        ref: null,
        data: {
          supplierName: '',
          ybCode: '',
          totalMoney: '',
          payProof: '',
          url: [],
          pic: []
        },
        rules: {},
        labelWidth: '140px'
      },
      picUrl: this.$global.httpBaseURL,
      show: true
    }
  },
  mounted () {
    let ybCode = this.$route.params.ybCode
    this.getBillList(ybCode)
    this.show = false
    setTimeout(() => {
      this.show = true
    }, 500)
  },
  watch: { // 解决打开多个页面之后显示同一账单数据
    urlYbCode: function (newVal) {
      if (!newVal) return
      this.getBillList(this.urlYbCode)
      this.show = false
      setTimeout(() => {
        this.show = true
      }, 500)
    },
    isPaystate: function () {
      this.handleFormClose()
      let ybCode = this.$route.params.ybCode
      this.$store.dispatch(GETBILLDETAIL, { ybCode: ybCode })
    },
    cancelBillState: function () {
      let ybCode = this.$route.params.ybCode
      this.$store.dispatch(GETBILLDETAIL, { ybCode: ybCode })
    }
  },
  computed: {
    upload () {
      return this.$refs.upload
    },
    isPaystate () {
      return billManage.state.payCost
    },
    urlYbCode () {
      return this.$route.params.ybCode
    },
    billList () {
      return billManage.state.billInfoList
    },
    costList () {
      return billManage.state.costList
    },
    costListPage () {
      return {
        rows: this.costList.list
      }
    },
    costGroup () {
      return [billManage.state.groupCost]
    },
    costGroupArr () {
      return []
    },
    costGrouplist () {
      return { rows: this.costGroupArr }
    },
    cancelBillState () {
      return billManage.state.cancelBill
    },
    fieldList () {
      let ary = [
        // { label: '序号', type: 'index', width: 150 },
        { label: '编号', prop: 'ycCode', align: 'center', type: 'slot', width: 280 },
        { label: '费用类型', prop: 'moneyType', width: 150, align: 'center' },
        { label: '收费项目', prop: 'name', width: 150, align: 'center' },
        { label: '配送仓点', prop: 'ydppName', width: 150, align: 'center' },
        { label: '计费方式', prop: 'computeTypeName', width: 180, align: 'center' },
        { label: '费用(元)', prop: 'money', align: 'center' },
        { label: '关联单号', prop: 'taskCode', type: 'slot', width: 280, align: 'center' },
        { label: '计费时间', prop: 'costTime', width: 150, align: 'center' },
        { label: '生成时间', prop: 'createTime', width: 180, align: 'center' }
        // { label: '计费方式', prop: 'computeType', align: 'center' }
      ]
      return ary
    },
    costFieldList () {
      return [
        { label: '费用类型', prop: 'name', width: 150 },
        { label: '费用(元)', prop: 'cost', align: 'left' }
      ]
    },
    formFieldList () {
      return [
        { label: '供应商名称：', prop: 'supplierName', type: 'text', required: true, labelWidth: '150px' },
        { label: '账单总金额：', prop: 'totalMoney', type: 'text', required: true, labelWidth: '150px' },
        { label: '支付凭证：', prop: 'payProof', type: 'textarea', required: true, labelWidth: '150px', width: '40px', height: '50px', placeholder: '(必填)请输入支付流水号等凭证信息' },
        { label: '上传图片：', prop: 'url', type: 'slot', required: true, width: 50, height: 50, labelWidth: '150px' },
        { label: '账单编号', prop: 'ybCode', type: 'text', required: true, labelWidth: '150px', disabled: false }
      ]
    },
    urlPicArr () {
      let url = []
      let urlpic = this.billList.ybVoucherImgs || ''
      if (urlpic === '') {
        url = []
      } else if (urlpic !== '' && urlpic.indexOf(',') === -1) {
        url = [{ url: this.picUrl + '/image/' + urlpic }]
      } else {
        url = urlpic.split(',')
        for (let i = 0; i < url.length; i++) {
          url[i] = { url: this.picUrl + '/image/' + url[i] }
        }
      }
      return url
    },
    // 账号权限
    isAdmin () {
      return window.localStorage.getItem('identity') === '3'
    }
  },
  filters: {
    toFixed (val) {
      if (val != null) {
        return val.toFixed(2)
      }
    }
  },
  methods: {
    getBillList (ybCode) {
      this.$store.dispatch(GETBILLDETAIL, { ybCode: ybCode })
      this.$store.dispatch(GETGROUPCOST, { ybCode: ybCode })
    },
    handleFormClose () { // 关闭线下支付页面
      this.dialogData.visible = false
    },
    handleSubmit (data) { // 提交支付凭证
      let params = {
        ybCode: this.formInfo.data.ybCode,
        data: this.formInfo.data.payProof,
        url: (this.formInfo.data.url).toString()
      }
      if ((params.data).trim() === '' || (params.data).trim() === undefined) {
        this.$confirm('有必填项未填', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        })
      } else if ((params.data).length >= 200) {
        this.$confirm('支付凭证文本长度不能大于200', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        this.$store.dispatch(OFFLINEPAY, params)
      }
    },
    payOffline () { // 线下支付
      this.formInfo.data = {
        supplierName: this.billList.ybSupplierCode,
        totalMoney: this.billList.ybTotalMoney,
        ybCode: this.billList.ybCode,
        payProof: '',
        url: [],
        pic: []
      }
      this.dialogData.visible = true
    },
    handleCancelBill () { // 点击取消账单
      if (this.billList.ybIsLock === 1) {
        alert('账单锁定，请稍后再试')
        return false
      } else {
        this.$confirm('您确定要取消当前账单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch(CANCELBILL, { ybCode: this.billList.ybCode })
        }).catch(() => {
        })
      }
    },
    comeBack () { // 返回
      this.$router.push('/billManage/billManage')
    },
    detail (data) { // 查看详情
      if (data.moneyType !== '贴标费' && data.moneyType !== '包膜费') {
        this.toWarehouseDetail(data.taskCode, data.nature, data.finishYocType)
      }
    },
    detailYcCode (data) {
      let computeTypeName = ''
      if (data.moneyType === '其他费用') {
        return this.$router.push('/costmenu/OtherCostDetail/datails/' + data.ycCode + '/' + parseFloat(data.money).toFixed(2))
      } else {
        if (data.computeTypeName.indexOf('重量') !== -1) {
          computeTypeName = '重量'
        } else {
          computeTypeName = data.computeTypeName
        }

        if (data.moneyType === '退货费') {
          this.$router.push('/costmenu/returncostdetail/' + data.ycCode + '/' + parseFloat(data.money).toFixed(2) + '/' + computeTypeName + '/' + data.nature + '/' + data.finishYocType)
        } else if (data.moneyType === '仓储费') {
          this.$router.push('/costmenu/warehousingdetai/' + data.ycCode + '/' + data.computeType)
        } else if (data.moneyType === '配送费') {
          this.$router.push('/costmenu/runErrandsdetail/' + data.ycCode + '/' + parseFloat(data.money).toFixed(2) + '/' + computeTypeName + '/' + data.nature + '/' + data.finishYocType)
        } else if (data.moneyType === '装卸费') {
          this.$router.push('/costmenu/handlinggoodsdetail/' + data.ycCode + '/' + parseFloat(data.money).toFixed(2))
        }
      }
    },
    handleStatusSelect (index) {
      if (index === '-1') {
        this.costClass = 'costInfo div-show'
        this.countClass = 'billStat div-hide'
      } else {
        let obj = this.costGroup[0].obj
        let name = [
          { wareHouseMoney: '仓储费' }, { moveMoney: '装卸费' }, { sendMoney: '配送费' }, { returnMoney: '退货费' }, { lableMoney: '贴标费' }, { coatedMoney: '包膜费' }, { otherMoney: '其他费用' }]
        if (this.costGroupArr.length === 0) {
          for (let i = 0; i < name.length; i++) {
            let costKey = Object.keys(name[i])
            let costName = Object.values(name[i]).toString()
            this.costGroupArr.push({ cost: obj[costKey], name: costName })
          }
        }
        this.costClass = 'costInfo div-hide'
        this.countClass = 'billStat div-show'
      }
    },
    buttonHide (data, flag) {
      if (flag === 1) if (data.ybIsLock === 0 && data.ybStatus === 0) return true// 取消账单按钮 线下支付按钮 的显示与隐藏
      if (flag === 0) if (data.ybStatus === 0) return true// 已取消已支付的账单隐藏返回按钮
    }
  },
  mixins: [toWarehouse]
}
</script>
<style scoped>
.supplier-info {
  background: #fff;
  height: 280px;
  border-radius: 2px;
  margin-top: 8px;
  padding-left: 30px;
}
.supplier-info > p,
.supplier-info > div {
  padding-top: 5px;
}
.supplier-info table {
  float: left;
  background: #fff;
  padding-right: 100px;
}
.billInfo {
  background: #fff;
}
.div-show {
  display: block;
}
.div-hide {
  display: none;
}
.billInfo span {
  display: inline-block;
  width: 70px;
  margin-bottom: 10px;
  margin-left: 10px;
}
.hi_lite {
  color: #67b6ff;
  border-bottom: #23a9f2 solid 2px;
  padding: 0 10px 5px 10px;
}
.down_lite {
  color: #888;
  padding: 0 10px 5px 10px;
}
.supplier-info p,
.supplier-info div {
  padding-bottom: 8px;
}
.supplier-info {
  overflow: hidden;
  font-size: 15px;
  padding-bottom: 50px;
  padding-left: 50px;
  position: relative;
}
.head-tit {
  padding-left: 5px;
}

.supplierName {
  height: 80px;
  margin-top: 30px;
  overflow: hidden;
  zoom: 1;
  width: 1200px;
}
.supplierName img {
  width: 32px;
  height: 32px;
  padding-right: 10px;
}
.supplierName img,
.supplierName h3 {
  float: left;
  line-height: 32px;
}
/* .supplierName h3 {
  padding-right: 500px;
} */
.supplierName .pay-status,
.supplierName .bill-total {
  float: left;
  width: 100px;
  color: #888;
  text-align: right;
}
.supplierName .pay-status span,
.supplierName .bill-total span {
  color: #000;
  /* font-size: 22px; */
}
.bill-desc {
  position: absolute;
  top: 75px;
  padding-left: 40px;
  color: #272727;
  line-height: 25px;
  width: 1200px;
}
.bill-text {
  display: inline-block;
  width: 300px;
  color: #888;
}
.button-list {
  height: 80px;
  text-align: center;
  line-height: 80px;
}
.content-box {
  background: #fff !important;
}
.el-card__body {
  padding: 0 !important;
}
.defSpan {
  width: 60%;
  display: inline;
}
.pay-type {
  float: left;
}

.pay-style {
  overflow: hidden;
  zoom: 1;
  float: right;
}

.pay-style .pay-status,
.pay-style .pay-money {
  float: left;
  padding-right: 30px;
  text-align: right;
}
.pay-time {
  clear: both;
}
/* .pay-down-style {
  position: absolute;
  top: 40px;
} */
</style>



// WEBPACK FOOTER //
// src/page/billManage/billCheck.vue